import SubPage from '../subpages/SubPage';
import { Switch, Route } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import Notice from '../subpages/Notice';
import QNA from '../subpages/QNA';
import SNS from '../subpages/SNS';
import makeQuest from '../subpages/MakeQuest';

import DashBoardResult from '../subpages/DashBoardResult';

const DashBoard = ({ history }) => {
  const title = '게시판';
  const parent_link = 'dashboard';
  const side_list = [
    ['notice?pageNo=1', '공지사항'],
    ['qna?pageNo=1', 'Q&A'],
  ];
  const bg_info = {
    link: 'https://user-images.githubusercontent.com/46194004/123917624-f5c05100-d9bd-11eb-8c39-d7fe2857f94b.png',
    text: title,
  };
  return (
    <div style={{ minHeight: '70rem' }}>
      <SubPage
        title={title}
        parent_link={parent_link}
        side_list={side_list}
        background_info={bg_info}
      />
      <Container fluid className="col-lg-8 offset-lg-3">
        <Switch>
          <Route path={`/${parent_link}/notice`} exact component={Notice} />
          <Route path={`/${parent_link}/notice/:articleId`} component={DashBoardResult} />
          <Route path={`/${parent_link}/qna/question`} component={makeQuest} />
          <Route path={`/${parent_link}/qna/:articleId`} component={DashBoardResult} />
          <Route
            path={`/${parent_link}/qna`}
            // render={() => <QNA history={history} />}
            component={QNA}
          />
          <Route path={`/${parent_link}/gallery`} component={SNS} />
        </Switch>
      </Container>
    </div>
  );
};
export default DashBoard;
